import {
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Drawer } from "antd";
import axios from "axios";
import moment from "moment";
import PropTypes from "prop-types";
import React, { ReactElement, useCallback, useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { authenticateToken } from "../../../utils/auth";
import { responseNotification } from "../../../utils/notify";
import { useParams } from "react-router";
import CampaignLayout from "../Layout";
import AddCampaign from "../AddCampaign";
 
import HubHeader from "../Layout/topHeader";
import { useDispatch } from "react-redux";
import { SET_CAMPAIGN_INFO } from "../../../redux/auth/authType";

const CampaignDetails = (): ReactElement => {
  const [singleHubInfo, setSingleHubInfo] = useState({
    loading: false,
    data: null,
  });

  const [selectedHubForEdit, setSelectedHubForEdit] = useState(undefined);
  const [visible, setVisible] = useState(false);
  const route = useParams();

  const dispatch = useDispatch();

  const fetchCampaignDetails = useCallback((getcampaignId) => {
    if (getcampaignId) {
      try {
        setSingleHubInfo({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/admin/campaign/details/${getcampaignId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setSingleHubInfo({
                loading: false,
                data: data?.data?.campaign,
              });
              dispatch({
                type: SET_CAMPAIGN_INFO,
                payload: {
                  campaignInfo: {
                    id: data?.data?.campaign?.id,
                    name: data?.data?.campaign?.name,
                    colorCode: data?.data?.campaign?.colorCode,
                    banner: data?.data?.campaign?.banner,
                    bannerWeb: data?.data?.campaign?.bannerWeb,
                    type: data?.data?.campaign?.type,
                  },
                },
              });
            } else {
              setSingleHubInfo({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setSingleHubInfo({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setSingleHubInfo({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  useEffect(() => {
    fetchCampaignDetails((route as any)?.campaignId);
  }, [fetchCampaignDetails, route]);

  useEffect(() => {
    if (visible) {
      setSelectedHubForEdit(undefined);
    }
  }, [selectedHubForEdit, visible]);

  useEffect(() => {
    setSelectedHubForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedHubForEdit(null);
    fetchCampaignDetails((route as any)?.campaignId);
  };

  const campaign = singleHubInfo?.data;

  return (
    <React.Fragment>
      <CampaignLayout campaignId={(route as any)?.campaignId as string}>
        <div className="bg-white">
          <HubHeader
            leftarea={"Campain Details"}
            rightarea={
              <Button
                type="dashed"
                onClick={() => setSelectedHubForEdit(singleHubInfo.data)}
              >
                <EditOutlined /> Edit
              </Button>
            }
          />
          <div className="details-area">
            <div className="pt-4">
              <div className="inner-body">
                <div className="single">
                  <span className="info-name">Campaign Name</span>
                  <span className="info-desc">{campaign?.name}</span>
                </div>

                <div className="single">
                  <span className="info-name">ID</span>
                  <span className="info-desc">{campaign?.id}</span>
                </div>

                <div className="single">
                  <span className="info-name">Description</span>
                  <span className="info-desc">{campaign?.description}</span>
                </div>

                <div className="single">
                  <span className="info-name">Display Order</span>
                  <span className="info-desc">{campaign?.displayOrder}</span>
                </div>

                <div className="single">
                  <span className="info-name">Start Date</span>
                  <span className="info-desc">
                    {moment(campaign?.startAt).format("lll")}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Endign Date</span>
                  <span className="info-desc">
                    {moment(campaign?.endAt).format("lll")}
                  </span>
                </div>

                {campaign?.shopId && (
                  <div className="single">
                    <span className="info-name">Shop Id</span>
                    <span className="info-desc">{campaign?.shopId}</span>
                  </div>
                )}

                {campaign?.parentCampaign && (
                  <div className="single">
                    <span className="info-name">Parent Campaign</span>
                    <span className="info-desc">
                      {campaign?.parentCampaign}
                    </span>
                  </div>
                )}

                <div className="single">
                  <span className="info-name">Type</span>
                  <span className="info-desc">
                    {campaign?.type?.replace("_", " ")}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Color Code</span>
                  <span className="info-desc">
                    <Avatar
                      style={{
                        background: campaign?.colorCode,
                        marginRight: 10,
                      }}
                    />
                    <span className="name mr-2">{campaign?.colorCode}</span>
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Status</span>
                  <div className="info-desc">
                    <span
                      className={`radius-btn text-uppercase ${
                        campaign?.isActive === false ? "inactive" : "active"
                      }-btn`}
                    >
                      {campaign?.isActive === false ? (
                        <>
                          <CloseOutlined className="mr-1" /> Inactive
                        </>
                      ) : (
                        <>
                          <CheckOutlined className="mr-1" /> Active{" "}
                        </>
                      )}
                    </span>
                  </div>
                </div>

                <div className="single">
                  <span className="info-name">Created Date</span>
                  <span className="info-desc">
                    {moment(campaign?.createdAt).format("lll")}
                  </span>
                </div>

                {visible ? (
                  <QuestionCircleOutlined
                    onClick={() => {
                      setVisible(false);
                    }}
                  />
                ) : (
                  <QuestionCircleOutlined
                    onClick={() => {
                      setVisible(true);
                    }}
                  />
                )}

                {visible && (
                  <div className="">
                    <h6 className="mt-5 title" style={{ width: "98%" }}>
                      Activity Logs
                    </h6>
                    <div className="inner-body">
                      <div className="single">
                        <span className="info-name">Created Date</span>
                        <span className="info-desc">
                          {moment(campaign?.createdAt).format("lll")}
                        </span>
                      </div>

                      {campaign?.createdBy?.name ? (
                        <div className="single">
                          <span className="info-name">Created By</span>
                          <span className="info-desc">
                            {campaign?.createdBy?.name}
                          </span>
                        </div>
                      ) : undefined}

                      <div className="single">
                        <span className="info-name">Contact</span>
                        <span className="info-desc">
                          {campaign?.createdBy?.mobileNumber ||
                            campaign?.createdBy?.email}
                        </span>
                      </div>
                    </div>
                    {campaign?.updatedAt ? (
                      <div className="inner-body mt-4">
                        <div className="single">
                          <span className="info-name">Updated Date</span>
                          <span className="info-desc">
                            {moment(campaign?.updatedAt).format("lll")}
                          </span>
                        </div>

                        {campaign?.updatedBy?.name ? (
                          <div className="single">
                            <span className="info-name">Updated By</span>
                            <span className="info-desc">
                              {campaign?.updatedBy?.name}
                            </span>
                          </div>
                        ) : undefined}

                        {campaign?.updatedBy?.mobileNumber ? (
                          <div className="single">
                            <span className="info-name">Contact</span>
                            <span className="info-desc">
                              {campaign?.updatedBy?.mobileNumber ||
                                campaign?.updatedBy?.email}
                            </span>
                          </div>
                        ) : undefined}
                      </div>
                    ) : undefined}
                  </div>
                )}
              </div>
            </div>
          </div>

          <Drawer
            title={selectedHubForEdit ? "Edit Campaign" : ""}
            width={600}
            onClose={() => {
              setSelectedHubForEdit(null);
            }}
            visible={selectedHubForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            <AddCampaign
              visibleData={selectedHubForEdit}
              onCloseMethod={onClose}
            />
          </Drawer>
        </div>
      </CampaignLayout>
    </React.Fragment>
  );
};
CampaignDetails.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default CampaignDetails;
